angular.module('app').factory('UserBig', function ($resource) {
    return $resource('https://codeforces.com/api/user.info?handles=:users', {users: '@users'}, {
        query: {method: 'GET', isArray: false}
    })
});
